"use strict";
import StatusIcon from "components/Identicon/StatusIcon";
import { topazIdAvatar, useTopazIdProfile } from "hooks/useTopazIdProfile";
import styled from "lib/styled-components";
import { useEffect, useState } from "react";
const AvatarImage = styled.img`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
`;
export function TopazIdStatusIcon({
  account,
  size,
  showMiniIcons = true
}) {
  const { data: profile } = useTopazIdProfile(account);
  const avatar = topazIdAvatar(profile);
  const [errored, setErrored] = useState(false);
  useEffect(() => {
    setErrored(false);
  }, [avatar]);
  if (account && avatar && !errored) {
    return <AvatarImage src={avatar} size={size} alt="Topaz ID avatar" onError={() => setErrored(true)} />;
  }
  return <StatusIcon size={size} showMiniIcons={showMiniIcons} address={account} />;
}
